<script setup lang="ts">
const highlights = [
  { icon: 'i-lucide-calendar', value: '7+ Years', label: 'Professional Experience' },
  { icon: 'i-lucide-briefcase', value: 'End-to-End', label: 'Product Development' },
  { icon: 'i-lucide-map-pin', value: 'West Java', label: 'Indonesia · Open to Remote' }
]
</script>

<template>
  <section
    id="about"
    class="py-12"
  >
    <h2 class="text-xs font-semibold uppercase tracking-widest text-muted mb-6">
      About
    </h2>

    <div class="grid md:grid-cols-3 gap-8">
      <div class="md:col-span-2 space-y-3 text-base text-muted leading-relaxed">
        <p>
          I'm a Fullstack Web Developer with over 7 years of hands-on experience
          building web applications across a wide range of industries.
        </p>
        <p>
          My expertise spans enterprise CMS platforms (Drupal, WordPress) to modern JavaScript frameworks
          (Vue.js, Nuxt.js, React, Next.js) and backend systems (PHP, Laravel, Node.js).
          I've led end-to-end product builds — from architecture and API design to frontend implementation and deployment.
        </p>
        <p>
          I care deeply about performance, clean code, and shipping products that users love.
        </p>
      </div>

      <div class="space-y-3">
        <div
          v-for="highlight in highlights"
          :key="highlight.label"
          class="flex items-center gap-3 p-3 rounded-xl border border-default bg-elevated"
        >
          <UIcon
            :name="highlight.icon"
            class="text-primary shrink-0 size-4"
          />
          <div>
            <p class="font-semibold text-highlighted text-base leading-none">
              {{ highlight.value }}
            </p>
            <p class="text-sm text-muted mt-0.5">
              {{ highlight.label }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
